// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Y2SB","container":"styles_container__2Lt8i","title":"styles_title__3ermx","wrapper":"styles_wrapper__3cii9","answer":"styles_answer__Fg8rp"};